<script>
    import { fly } from "svelte/transition";
import { show } from "../components/toast/notifier";
    import { InputNumber,Toast,notify } from "../index";

    function handleChange(e){
        console.log(1111);
    }
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <InputNumber on:change={(e)=>{
            console.log(e.detail);
        }} />
    </div>
    <h4 class="example-title">步长设置</h4>
    <div class="example-body">
        <InputNumber step={10} on:change={(e)=>{
            console.log(e.detail);
        }} />
    </div>
    <h4 class="example-title">限制输入范围</h4>
    <div class="example-body">
        <InputNumber min={-5} max={5} on:change={(e)=>{
            console.log(e.detail);
        }} />
    </div>
    <h4 class="example-title">格式化到整数</h4>
    <div class="example-body">
        <InputNumber digits={0} value={5} on:change={(e)=>{
            console.log(e.detail);
        }} />
    </div>
    <h4 class="example-title">格式化到一位小数</h4>
    <div class="example-body">
        <InputNumber digits={1} value={5} on:change={(e)=>{
            console.log(e.detail);
        }} />
    </div>
    <h4 class="example-title">禁用状态</h4>
    <div class="example-body">
        <InputNumber disabled digits={1} value={5} on:change={(e)=>{
            console.log(e.detail);
        }} />
    </div>
    
    <h4 class="example-title">输入框只读状态</h4>
    <div class="example-body">
        <InputNumber inputReadOnly digits={1} value={5} on:change={(e)=>{
            console.log(e.detail);
        }} />
    </div>
    <h4 class="example-title">自定义宽度</h4>
    <div class="example-body">
        <InputNumber inputReadOnly --width="120px" on:change={(e)=>{
            console.log(e.detail);
        }} />
    </div>
    <h4 class="example-title">获得/失去焦点</h4>
    <div class="example-body">
        <InputNumber on:focus={()=>notify.show('获得焦点')} on:blur={()=>notify.show('失去焦点')} on:change={(e)=>{
            console.log(e.detail);
        }} />
    </div>
    
</div>
<Toast/>
<style lang="less">
    @import "./example.less";
    .rect {
        background: #eee;
        width: 40px;
        height: 40px;
        display: block;
        border-radius: 8px;
    }
</style>
